import React from 'react';

const AboutHero = () => {
  return (
    <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-8">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900">
            About <span className="text-blue-600">Us</span>
          </h1>
          <p className="text-2xl sm:text-3xl font-semibold text-gray-700 max-w-4xl mx-auto">
            Empowering Startups for Exponential Growth
          </p>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Navigating the complexities of gaining early adopters and validating product ideas poses a significant challenge for early-stage startups, attributed to diverse factors. Upscale was established with the purpose of tackling these challenges, providing founders and startups with a strategic advantage in their pursuit of sustainable growth from the outset.
          </p>
        </div>

        {/* Hero Image */}
        <div className="mt-16 relative">
          <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg"
              alt="About Upscale Team"
              className="w-full h-[400px] object-cover"
            />
          </div>
          <div className="absolute -bottom-4 -right-4 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30"></div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;